import { render } from "./OrderedGoods.vue?vue&type=template&id=68348d95&scoped=true&ts=true"
import script from "./OrderedGoods.vue?vue&type=script&lang=ts"
export * from "./OrderedGoods.vue?vue&type=script&lang=ts"

import "./OrderedGoods.vue?vue&type=style&index=0&id=68348d95&lang=scss&scoped=true"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68348d95"]])

export default __exports__